import { TOGGLE_CONFIRMATION_LEAVING_ITINERARY } from "./displayConfirmationLeavingItineraryReducer"

export const toggleConfirmationLeavingItinerary = (value) => ({
    type: TOGGLE_CONFIRMATION_LEAVING_ITINERARY,
    payload: value
})